$(function() {
  var subModalLabelTemplate = $('#subModalLabelTemplate label');
  var subListItemTemplate = $('#subListItemTemplate li');
  var subListItemDetailsTemplate = $('#subListItemDetailsTemplate table');
  var discountSubTemplate = $('#discountSubTemplate li');

  // manage account
  var manageAccountModal = $('#manageAccountModal');

  // Reload current page, optionally without hash
  var reload = function(withoutHash) {
    if (withoutHash) {
      AVState.replace({
        url: window.location.pathname + window.location.search
      });
    }
    
    window.location.reload();
  }

  manageAccountModal.on('show.bs.modal', function(e) {
    var subTitle = $(this).find('.sub-title');
    var profilePic = $(this).find('.profile');
    var buttonGroup = $(this).find('.btn-group');
    var modalButton = buttonGroup.find('button[data-toggle="modal"]');

    var userSubId = modalButton.data('userSub');
    var username = modalButton.data('username');
    var profileSrc = modalButton.data('profileSrc');
    
    if (!(e.relatedTarget || userSubId)) {
      e.preventDefault();
      return;
    }

    // update user sub data
    if (e.relatedTarget) {
      var button = $(e.relatedTarget);
      
      userSubId = parseInt(button.data('userSub'));
      
      username = button.data('username');
      subTitle.html(username);
      
      profileSrc = button.data('profileSrc');
      if (profileSrc) {
        profilePic.attr('src', profileSrc);
      } else {
        profilePic.removeAttr('src');
      }

      modalButton.data('userSub', userSubId);
      modalButton.data('username', username);
      modalButton.data('profileSrc', profileSrc);
    }
  });

  // manage sub modal
  var manageSubModal = $('#manageSubModal');

  manageSubModal.on('show.bs.modal', function(e) {
    var subTitle = $(this).find('.sub-title');
    var profilePic = $(this).find('.profile');
    var subscribeForm = $(this).find('form');
    var userSubInput = subscribeForm.find('input[name="user-sub"]');
    var subsInput = subscribeForm.find('.input-subs').selectDropdown();
    var subsDropMenu = subsInput.find('.dropdown-menu');
    var subDetails = subscribeForm.find('.sub-details');
    var loading = subscribeForm.find('> .loading');
    var buttonGroup = subscribeForm.find('.btn-group');
    var submitButton = buttonGroup.find('button[type="submit"]');
    var cancelButton = buttonGroup.find('button[data-target="#cancelModal"]');
    var removeButton = buttonGroup.find('button[data-target="#removeModal"]');

    var userSubId = userSubInput.val();
    var username = subTitle.html();
    var profileSrc = profilePic.attr('src');

    if (!(e.relatedTarget || userSubId)) {
      e.preventDefault();
      return;
    }

    // update user sub data
    if (e.relatedTarget) {
      var button = $(e.relatedTarget);
      
      userSubId = parseInt(button.data('userSub'));
      userSubInput.val(userSubId);
      
      username = button.data('username');
      subTitle.html(username);
      
      profileSrc = button.data('profileSrc');
      if (profileSrc) {
        profilePic.attr('src', profileSrc);
      } else {
        profilePic.removeAttr('src');
      }
    }

    submitButton.hide();
    cancelButton.hide();
    removeButton.hide();
    submitButton.prop('disabled', true);
    submitButton.removeClass('btn-loading');
    subsInput.hide();
    subsDropMenu.find('li').remove();
    subDetails.hide();
    subDetails.find('table').remove();
    loading.show();
    
    // get user subscription details
    userSubResource.get(userSubId, {
      success: function(userSub) {
        userSubResource.getAvailablePackages(userSubId, {
          success: function(subscriptions) {

            // add subscription packages
            var selectedItem;

            for (var i = 0; i < subscriptions.length; i++) {
              var subscription = subscriptions[i];
      
              var subListItem = subListItemTemplate.clone();
              
              var subItem = subListItem.find('a');

              subItem.data('value', subscription.id);
              subItem.data('subscription', {
                id: subscription.id,
                price: subscription.price,
                period: subscription.period,
                period_short_display: subscription.period_short_display
              });

              subItem.html(
                subItem.html().replace(
                  '{count}', subscription.count_display
                ).replace(
                  '{price}', subscription.price
                ).replace(
                  '{period}', subscription.period_short_display
                )
              );

              var subCurrent = subItem.find('.sub-current');

              if (userSub.active && subscription.id === userSub.subscription_id) {
                // Select the current user subscription
                selectedItem = subItem[0];
                subCurrent.show();
              } else {
                subCurrent.hide();
              }
      
              subsDropMenu.append(subListItem);
            }

            subsInput.bindItems();
            
            subsInput.onItemSelected(function(selectedItem) {
              var selectedItemDetails = subListItemDetailsTemplate.clone();

              var subscription = selectedItem.data('subscription');

              var isCurrent = userSub.active && userSub.subscription_id === subscription.id;

              var billingDate = isCurrent ? moment.unix(userSub.sub_next) : moment().add(1, subscription.period);

              var html;
              if (isCurrent && userSub.billing_info) {
                html = selectedItemDetails.html().replace(
                  '{ccSrc}', '<img src="/assets/img/payment/card-' + userSub.billing_info.cc_type_short + '.svg"/>'
                ).replace(
                  '{ccNumber}', userSub.billing_info.cc_number.slice(-4)
                )
                
                submitButton.prop('disabled', true);
              } else {
                selectedItemDetails.find('.payment-info').remove();

                html = selectedItemDetails.html();

                submitButton.prop('disabled', false);
              }

              selectedItemDetails.html(html.replace(
                '{price}', subscription.price
              ).replace(
                '{period}', subscription.period_short_display
              ).replace(
                '{billingDate}', billingDate.format('MMM D, YYYY')
              ));
              subDetails.html(selectedItemDetails);
            });

            subsInput.selectItem(selectedItem);

            // show sub details
            subDetails.show();
    
            // set submit button
            submitButton.show();
    
            // set cancel button
            cancelButton.data('userSub', userSubId);
            cancelButton.data('username', username);
            cancelButton.data('profileSrc', profileSrc);
            cancelButton.data('expireDate', userSub.sub_next);
            
            if (userSub.active) {
              if (!userSub.unsubscribed) {
                cancelButton.show();
              } else {
                cancelButton.hide();
              }
            } else {
              cancelButton.hide();
            }

            // set remove button
            removeButton.data('userSub', userSubId);
            removeButton.data('username', username);
            removeButton.data('profileSrc', profileSrc);

            if (userSub.active) {
              removeButton.hide();
            } else {
              removeButton.show();
            }
            
            subsInput.show();
            loading.hide();
          },
          error: function(xhr, status, err) {
            AVNotify(xhr.responseJSON && xhr.responseJSON.message ? xhr.responseJSON.message : err, 'danger', null, null, true);
            reload(true);
          }
        });
      },
      error: function(xhr, status, err) {
        AVNotify(xhr.responseJSON && xhr.responseJSON.message ? xhr.responseJSON.message : err, 'danger', null, null, true);
        reload(true);
      }
    });
  });

  manageSubModal.find('form').on('submit', function(e) {
    var submitButton = manageSubModal.find('button[type="submit"]');

    submitButton.prop('disabled', true);
    submitButton.addClass('btn-loading');
  });

  var confirmSubModal = $('#confirmSubModal');
  
  if (confirmSubModal.length) {
    var updateSubInfo = function(input) {
      if (input.length) {
        confirmSubModal.find('form button[type=submit]').prop('disabled', false);

        var table = confirmSubModal.find('table');
        likeCountRow = table.find('.sub-like-count');
        priceRow = table.find('.sub-price');

        if (input.data('active')) {
          likeCountRow.find('td').html(input.data('likeCount') + ' likes / post');
          priceRow.find('td').html(input.data('price') + ' / ' + input.data('period') + 'ly')
          priceRow.show();
        } else {
          likeCountRow.find('td').html('<span class="color-dark-red">Inactive</span>');
          priceRow.find('td').empty();
          priceRow.hide();
        }
      }
    }

    updateSubInfo(confirmSubModal.find('input[name="user-sub"]:checked'));
    confirmSubModal.find('input[name="user-sub"]').change(function() {
      if (this.checked) {
        updateSubInfo($(this));
      }
    });

    confirmSubModal.find('form').on('submit', function(e) {
      var submitButton = $(this).find('button[type="submit"]');

      submitButton.prop('disabled', true);
      submitButton.addClass('btn-loading');

      return true;
    });
  }

  // change sub modal
  $('#changeSubModal').on('show.bs.modal', function(e) {
    var profilePic = $(this).find('.profile');
    var subsList = $(this).find('#changeSubModalSubs');
    var loading = subsList.find('.loading');
    var subscribeForm = $(this).find('form');
    var userSubIdInput = subscribeForm.find('input[name="userSub"]')
    var instagramUserIdInput = subscribeForm.find('input[name="instagramUser"]');
    var buttonGroup = subscribeForm.find('.btn-group');
    var submitButton = buttonGroup.find('button[type="submit"]');

    var subId = subsList.find('input[checked]').val();
    var userSubId = userSubIdInput.val();
    var instagramUserId = instagramUserIdInput.val();
    var profileSrc;
    
    if (!(e.relatedTarget || subId || userSubId || instagramUserId)) {
      e.preventDefault();
      return;
    }

    // update sub data
    if (e.relatedTarget) {
      var button = $(e.relatedTarget);

      subId = parseInt(button.data('sub'));
      
      var userSub = button.data('userSub');
      if (userSub) {
        userSubId = parseInt(button.data('userSub'));
        userSubIdInput.attr('name', 'userSub');
        userSubIdInput.val(userSubId);
      } else {
        instagramUserId = parseInt(button.data('instagramUser'));
        instagramUserIdInput.attr('name', 'instagramUser');
        instagramUserIdInput.val(instagramUserId);
      }
      
      profileSrc = button.data('profileSrc');
      if (profileSrc) {
        profilePic.attr('src', profileSrc);
      } else {
        profilePic.removeAttr('src');
      }
    }

    submitButton.hide();
    submitButton.prop('disabled', true);
    submitButton.removeClass('btn-loading');
    subsList.find('label').remove();
    loading.show();

    var options = {
      success: function(subscriptions) {

        // add subscription packages
        for (var i = 0; i < subscriptions.length; i++) {
          var subscription = subscriptions[i];

          var subLabel = subModalLabelTemplate.clone();
          var subIdInput = subLabel.find('input');
          var subInfo = subLabel.find('.sub-info');

          subIdInput.val(subscription.id);

          if (subscription.id === subId) {
            // Select the current subscription
            subIdInput.prop('checked', true);
            submitButton.prop('disabled', false);
          }

          subInfo.html(
            subInfo.html().replace(
              '{count}', subscription.count_display
            ).replace(
              '{price}', subscription.price
            ).replace(
              '{period}', subscription.period_display
            )
          );

          subsList.append(subLabel);
        }

        // Select the first by default if no sub is selected
        var subSelected = subsList.find('input:checked');
        if (!subSelected.length && subscriptions.length) {
          subsList.find('input:first').prop('checked', true);
          submitButton.prop('disabled', false);
        }

        // handle package selection changes
        subsList.find('input').change(function() {
          if (this.checked) {
            submitButton.prop('disabled', false);
          }
        });

        submitButton.show();

        loading.hide();
      },
      error: function(xhr, status, err) {
        AVNotify(xhr.responseJSON && xhr.responseJSON.message ? xhr.responseJSON.message : err, 'danger', null, null, true);
        reload(true);
      }
    };

    if (userSubId) {
      userSubResource.getAvailablePackages(userSubId, options);
    } else {
      subResource.getPackages(options);
    }
  });

  // execute subscription modal
  $('#summarySubModal form').on('submit', function(e) {
    e.preventDefault();

    var inputs = $(this).find('input, button');
    var transaction_type = inputs.filter('input[name="transaction_type"]');
    var checkout_token = inputs.filter('input[name="checkout_token"]');
    var token = inputs.filter('input[name="token"]');
    var submitButton = inputs.filter('button[type="submit"]');

    inputs.prop('disabled', true);
    submitButton.removeClass('btn-loading');
    
    paymentResource.executeSubscription(transaction_type.val(), {
      checkout_token: checkout_token.val(),
      token: token.val()
    }, {
      success: function(resp) {
        if (resp.redirectUrl) {
          window.location = resp.redirectUrl;
        }
      },
      error: function(xhr, status, err) {
        AVNotify(xhr.responseJSON && xhr.responseJSON.message ? xhr.responseJSON.message : err, 'danger', null, null, true);
        window.location = '/my-subscriptions';
      }
    });
  });

  // cancel modal 
  var cancelModal = $('#cancelModal');
  var cancelModalRequired = cancelModal.find('select[required], textarea[required], input[required], button[required]');
  cancelModalRequired.bind('change keyup input', function() {
    $(this).setValid();
  });

  cancelModal.on('show.bs.modal', function(e) {
    var profilePic = $(this).find('.profile');
    var date = $(this).find('.date');
    var cancelForm = $(this).find('form');
    var inputs = cancelForm.find('select, textarea, input, button');
    var userSubInput = inputs.filter('input[name="user-sub"]');
    var reasonInput = inputs.filter('select[name="reason"]');
    var commentInput = inputs.filter('textarea[name="comment"]');
    var submitButton = inputs.filter('button[type="submit"]');

    if (!(e.relatedTarget || userSubInput.val())) {
      e.preventDefault();
      return;
    }

    // update user sub data
    if (e.relatedTarget) {
      var button = $(e.relatedTarget);
      var userSubId = parseInt(button.data('userSub'));
      var expireDate = button.data('expireDate');
      var profileSrc = button.data('profileSrc');
  
      // set defaults
      if (profileSrc) {
        profilePic.attr('src', profileSrc);
      } else {
        profilePic.removeAttr('src')
      }
      userSubInput.val(userSubId);
      
      date.html(moment.unix(expireDate).format('MMMM DD, YYYY'));
    }
    
    reasonInput.val('');
    commentInput.val('');

    cancelModalRequired.setValid();
    inputs.prop('disabled', false);
    submitButton.removeClass('btn-loading');
  });

  cancelModal.find('form').on('submit', function(e) {
    e.preventDefault();

    var valid = true;
    cancelModalRequired.each(function() {
      var required = $(this);
      if (!required.val()) {
        valid = false;
        required.setRequired();
      }
    });

    if (!valid) {
      return false;
    }

    var profileSrc = cancelModal.find('.profile').attr('src');
    var inputs = $(this).find('select, textarea, input, button');
    var userSubInput = inputs.filter('input[name="user-sub"]');
    var reasonInput = inputs.filter('select[name="reason"]');
    var commentInput = inputs.filter('textarea[name="comment"]');
    var submitButton = inputs.filter('button[type="submit"]');

    inputs.prop('disabled', true);
    submitButton.addClass('btn-loading');

    userSubResource.get(userSubInput.val(), {
      success: function(userSub) {
        var currentSub = userSub.subscription;

        userSubResource.getDiscountPackages(userSub.id, {
          success: function(subscriptions) {
            var userSubId = userSubInput.val();
            var reason = reasonInput.val();
            var comment = commentInput.val();
    
            var confirmCancelModal;
            if (subscriptions.length) {
              confirmCancelModal = confirmCancelModals.filter('#confirmCancelDiscountModal');
            } else {
              confirmCancelModal = confirmCancelModals.filter('#confirmCancelModal');
            }
            
            var confirmProfilePic = confirmCancelModal.find('.profile');
            var confirmDiscountUserSubs = confirmCancelModal.find('.discount-subs');
            var confirmCancelForm = confirmCancelModal.find('form');
            var confirmUserSubInput = confirmCancelForm.find('input[name="user-sub"]');
            var confirmReasonInput = confirmCancelForm.find('input[name="reason"]');
            var confirmCommentInput = confirmCancelForm.find('input[name="comment"]');
    
            if (profileSrc) {
              confirmProfilePic.attr('src', profileSrc);
            } else {
              confirmProfilePic.removeAttr('src');
            }

            confirmDiscountUserSubs.empty();
    
            for (var i = 0; i < subscriptions.length; i++) {
              var subscription = subscriptions[i];
              
              var subItem = discountSubTemplate.clone();
              var subTag = subItem.find('.sub-tag');
              var subDesc = subItem.find('.sub-description');
              var subDiscountPrice = subItem.find('.sub-price.discount');
              var subCurrentPrice = subItem.find('.sub-price.current');
              var subForm = subItem.find('form');

              subTag.html(
                subTag.html().replace(
                  '{tag}', subscription.parent ? Math.round(((currentSub.price - subscription.price) / currentSub.price) * 100) + '% OFF' : 'ONE TIME OFFER'
                )
              );

              subDesc.html(
                subDesc.html().replace(
                  '{count}', subscription.count_display
                )
              );

              subDiscountPrice.html(
                subDiscountPrice.html().replace(
                  '{price}', subscription.price
                ).replace(
                  '{period}', subscription.period_short_display
                )
              );
              
              if (subscription.parent) {
                subCurrentPrice.html(
                  subCurrentPrice.html().replace(
                    '{price}', currentSub.price
                  ).replace(
                    '{period}', currentSub.period_short_display
                  )
                );
              } else {
                subCurrentPrice.empty();
              }

              subForm.find('input[name="user-sub"]').val(userSub.id);
              subForm.find('input[name="subscription"]').val(subscription.id);;
    
              confirmDiscountUserSubs.append(subItem);
            }
            
            confirmUserSubInput.val(userSubId);
            confirmReasonInput.val(reason);
            confirmCommentInput.val(comment);
    
            confirmCancelModal.modal('show');
          },
          error: function(xhr, status, err) {
            AVNotify(xhr.responseJSON && xhr.responseJSON.message ? xhr.responseJSON.message : err, 'danger', null, null, true);
            reload(true);
          }
        });
      },
      error: function(xhr, status, err) {
        AVNotify(xhr.responseJSON && xhr.responseJSON.message ? xhr.responseJSON.message : err, 'danger', null, null, true);
        reload(true);
      }
    });
  });

  // confirm cancel modal 
  var confirmCancelModals = $('#confirmCancelModal, #confirmCancelDiscountModal');

  confirmCancelModals.on('show.bs.modal', function(e) {
    var profilePic = $(this).find('.profile');
    var confirmCancelForm = $(this).find('form');
    var userSubInput = confirmCancelForm.find('input[name="user-sub"]');
    var reasonInput = confirmCancelForm.find('input[name="reason"]');
    var commentInput = confirmCancelForm.find('input[name="comment"]');
    var submitButton = confirmCancelForm.find('button[type="submit"]');

    if (!(e.relatedTarget || userSubInput.val())) {
      e.preventDefault();
      return;
    }

    // update user sub data
    if (e.relatedTarget) {
      var button = $(e.relatedTarget);
      var userSubId = parseInt(button.data('userSub'));
      var profileSrc = button.data('profileSrc');
      
      if (profileSrc) {
        profilePic.attr('src', profileSrc);
      } else {
        profilePic.removeAttr('src');
      }
      userSubInput.val(userSubId);
      reasonInput.val(reason);
      commentInput.val(comment);
    }
   
    submitButton.removeClass('btn-loading');
  });

  confirmCancelModals.find('form').on('submit', function(e) {
    e.preventDefault();

    var inputs = $(this).find('input, button');
    var userSubInput = inputs.filter('input[name="user-sub"]');
    var reason = inputs.filter('input[name="reason"]');
    var comment = inputs.filter('input[name="comment"]');
    var submitButton = inputs.filter('button[type="submit"]');

    inputs.prop('disabled', true);
    submitButton.addClass('btn-loading');

    userSubResource.cancelSubscription(userSubInput.val(), {
      reason: reason.val(),
      comment: comment.val()
    }, {
      success: function(resp) {
        AVNotify(resp.message, 'success', true, 5, true);
        reload(true);
      },
      error: function(xhr, status, err) {
        AVNotify(xhr.responseJSON && xhr.responseJSON.message ? xhr.responseJSON.message : err, 'danger', null, null, true);
        reload(true);
      }
    });
  });
  
  // remove modal
  $('#removeModal').on('show.bs.modal', function(e) {
    var profilePic = $(this).find('.profile');
    var removeForm = $(this).find('form');
    var userSubInput = removeForm.find('input[name="user-sub"]');
    var submitButton = removeForm.find('button[type="submit"]');
    
    if (!(e.relatedTarget || userSubInput.val())) {
      e.preventDefault();
      return;
    }

    // update user sub data
    if (e.relatedTarget) {
      var button = $(e.relatedTarget);
      var userSubId = parseInt(button.data('userSub'));
      var profileSrc = button.data('profileSrc');
  
      if (profileSrc) {
        profilePic.attr('src', profileSrc);
      } else {
        profilePic.removeAttr('src')
      }
      userSubInput.val(userSubId);
    }

    submitButton.removeClass('btn-loading');
  });

  $('#removeModal form').on('submit', function(e) {
    e.preventDefault();

    var inputs = $(this).find('select, textarea, input, button');
    var userSubInput = inputs.filter('input[name="user-sub"]');
    var submitButton = inputs.filter('button[type="submit"]');
    
    inputs.prop('disabled', true);
    submitButton.addClass('btn-loading');

    userSubResource.removeSubscription(userSubInput.val(), {
      success: function(resp) {
        AVNotify(resp.message, 'success', true, 5, true);
        reload(true);
      },
      error: function(xhr, status, err) {
        AVNotify(xhr.responseJSON && xhr.responseJSON.message ? xhr.responseJSON.message : err, 'danger', null, null, true);
        reload(true);
      }
    })
  });

  // change instagram user modal
  $('#igUserModal').on('show.bs.modal', function(e) {
    var subTitle = $(this).find('.sub-title');
    var profilePic = $(this).find('.profile');
    var igUserForm =  $(this).find('form');
    var userSubInput = igUserForm.find('input[name="user-sub"]');
    var igUserInput = igUserForm.find('input[name="username"]');
    var submitButton = igUserForm.find('button[type="submit"]');

    if (!(e.relatedTarget || userSubInput.val())) {
      e.preventDefault();
      return;
    }

    // set user sub data
    if (e.relatedTarget) {
      var button = $(e.relatedTarget);
      var userSubId = parseInt(button.data('userSub'));
      var username = button.data('username');
      var profileSrc = button.data('profileSrc');
  
      // set defaults
      subTitle.html(username);
      if (profileSrc) {
        profilePic.attr('src', profileSrc);
      } else {
        profilePic.removeAttr('src')
      }
      userSubInput.val(userSubId);
      igUserInput.val(username);
    }

    submitButton.removeClass('btn-loading');
  });

  // Add a new Instagram Account
  var addUserSubModal = $('#addUserSubModal');
  var newSubModal = $('#newSubModal');

  // Bind notifications/events for adding a new Instagram Account
  var addUserNotify = addUserSubModal.find('.av-notify').notify();
  var addUserInputs = addUserSubModal.find('input, button');
  addUserInputs.bind('change keyup input', function() {
    addUserNotify.hideNotify();
  });

  addUserSubModal.on('show.bs.modal', function() {
    var buttonGroup = $(this).find('.btn-group');
    var submitButton = buttonGroup.find('button[type="submit"]');

    addUserInputs.val('');
    addUserInputs.prop('disabled', false);
    submitButton.prop('disabled', true);
    submitButton.removeClass('btn-loading');
  });

  addUserSubModal.find('#igForm').on('submit', function(e) {
    e.preventDefault();

    var iguser = addUserInputs.filter('input[name="iguser"]');
    var isCreditOnly = addUserInputs.filter('input[name="credit-only"]');
    var submitButton = addUserInputs.filter('button[type="submit"]');

    // set defaults
    addUserInputs.prop('disabled', true);
    submitButton.addClass('btn-loading');
    addUserNotify.hideNotify();

    var onError = function(xhr, status, err) {
      addUserNotify.addNotify(xhr.responseJSON && xhr.responseJSON.message ? xhr.responseJSON.message : err, 'danger');
      addUserInputs.prop('disabled', false);
      submitButton.removeClass('btn-loading');
    }

    igResource.refresh(iguser.val(), {
      success: function (user) {
        if (isCreditOnly.prop('checked')) {
          userSubResource.add(user.username, {
            success: function (userSub) {
              window.location = '/dashboard/' + userSub.id
            },
            error: onError
          });
          return;
        }

        var profilePic = newSubModal.find('.profile');
        var username = newSubModal.find('.username');
        var instagramUserId = newSubModal.find('input[name="instagramUser"]');

        // set defaults
        profilePic.attr('src', 'https://ximg.automaticviral.com/' + user.picture);
        username.html(user.username);
        instagramUserId.val(user.id);
        
        newSubModal.modal('show');
      },
      error: onError
    });
  });

  newSubModal.on('show.bs.modal', function() {
    var subscribeForm = $(this).find('form');
    var subsInput = subscribeForm.find('.input-subs').selectDropdown();
    var subsDropMenu = subsInput.find('.dropdown-menu');
    var subDetails = subscribeForm.find('.sub-details');
    var loading = subscribeForm.find('> .loading');
    var buttonGroup = subscribeForm.find('.btn-group');
    var submitButton = buttonGroup.find('button[type="submit"]');

    submitButton.hide();
    submitButton.prop('disabled', true);
    submitButton.removeClass('btn-loading');
    subsInput.hide();
    subsDropMenu.find('li').remove();
    subDetails.hide();
    subDetails.find('table').remove();
    loading.show();
    
    // get subscription packages
    subResource.getPackages({
      success: function(subscriptions) {
        // add subscription packages
        var selectedItem;

        for (var i = 0; i < subscriptions.length; i++) {
          var subscription = subscriptions[i];
  
          var subListItem = subListItemTemplate.clone();
          
          var subItem = subListItem.find('a');

          subItem.data('value', subscription.id);
          subItem.data('subscription', {
            id: subscription.id,
            price: subscription.price,
            period: subscription.period,
            period_short_display: subscription.period_short_display
          });

          subItem.html(
            subItem.html().replace(
              '{count}', subscription.count_display
            ).replace(
              '{price}', subscription.price
            ).replace(
              '{period}', subscription.period_short_display
            )
          );

          subItem.find('.sub-current').remove();
  
          subsDropMenu.append(subListItem);
        }

        subsInput.bindItems();
        
        subsInput.onItemSelected(function(selectedItem) {
          var selectedItemDetails = subListItemDetailsTemplate.clone();

          var subscription = selectedItem.data('subscription');

          selectedItemDetails.find('.payment-info').remove();
          selectedItemDetails.find('.billing-date').remove();

          submitButton.prop('disabled', false);

          selectedItemDetails.html(selectedItemDetails.html().replace(
            '{price}', subscription.price
          ).replace(
            '{period}', subscription.period_short_display
          ));
          
          subDetails.html(selectedItemDetails);
        });

        subsInput.selectItem(selectedItem);

        // show sub details
        subDetails.show();

        // set submit button
        submitButton.show();
        
        subsInput.show();
        loading.hide();
      },
      error: function(xhr, status, err) {
        AVNotify(xhr.responseJSON && xhr.responseJSON.message ? xhr.responseJSON.message : err, 'danger', null, null, true);
        reload(true);
      }
    });
  });

  newSubModal.find('form').on('submit', function(e) {
    var submitButton = newSubModal.find('button[type="submit"]');

    submitButton.prop('disabled', true);
    submitButton.addClass('btn-loading');
  });

  var igUserModal = $('#igUserModal');

  igUserModal.on('show.bs.modal', function() {
    var submitButton = $(this).find('button[type="submit"]');
    
    // set defaults
    submitButton.prop('disabled', false);
  })

  igUserModal.find('form').on('submit', function(e) {
    e.preventDefault();

    var inputs = $(this).find('input, button');
    var userSubId = inputs.filter('input[name="user-sub"]');
    var igUsername = inputs.filter('input[name="username"]');
    var submitButton = inputs.filter('button[type="submit"]');

    // set defaults
    inputs.prop('disabled', true);
    submitButton.addClass('btn-loading');

    userSubResource.update(userSubId.val(), {
      username: igUsername.val()
    }, {
      success: function (resp) {
        AVNotify('Your Instagram username has been changed.', 'success', true, 5, true);
        reload(true);
      },
      error: function(xhr, status, err) {
        AVNotify(xhr.responseJSON && xhr.responseJSON.message ? xhr.responseJSON.message : err, 'danger', null, null, true);
        reload(true);
      },
    });
  });

  $('#summaryCreditsModal form').on('submit', function(e) {
    e.preventDefault();

    var inputs = $(this).find('input, button');
    var transaction_type = inputs.filter('input[name="transaction_type"]');
    var checkout_token = inputs.filter('input[name="checkout_token"]');
    var token = inputs.filter('input[name="token"]');
    var paymentId = inputs.filter('input[name="paymentId"]');
    var PayerID = inputs.filter('input[name="PayerID"]');
    var submitButton = inputs.filter('button[type="submit"]');

    inputs.prop('disabled', true);
    submitButton.addClass('btn-loading');

    paymentResource.executeCreditsPayment(transaction_type.val(), {
      checkout_token: checkout_token.val(),
      token: token.val(),
      paymentId: paymentId.val(),
      PayerID: PayerID.val()
    }, {
      success: function (resp) { 
        if (resp.redirectUrl) {
          window.location = resp.redirectUrl;
        }
      },
      error: function(xhr, status, err) {
        AVNotify(xhr.responseJSON && xhr.responseJSON.message ? xhr.responseJSON.message : err, 'danger', null, null, true);
        reload(true);
      }
    });
  });

  var deletePaymentMethodModal = $('#deletePaymentMethodModal')
  var deletePaymentMethodForm = $('#deletePaymentMethodModal form');
  var conflictPaymentMethodModal = $('#conflictPaymentMethodModal');

  deletePaymentMethodModal.on('show.bs.modal', function(e) {
    var billingId = $(this).find('input[name="billingId"]');
    var ccNumber = $(this).find('span.cc-number');
    var submitButton = $(this).find('button[type="submit"]');

    if (!(e.relatedTarget || billingId.val())) {
      e.preventDefault();
      return;
    }

    // update billing data
    if (e.relatedTarget) {
      var button = $(e.relatedTarget);
      
      // set defaults
      submitButton.prop('disabled', false);
      submitButton.removeClass('btn-loading');
  
      billingId.val(button.data('id'));
      ccNumber.text(button.data('ccNumber'));
      submitButton.data('ccNumber', button.data('ccNumber'));
    }
  });

  deletePaymentMethodForm.on('submit', function(e) {
    e.preventDefault();

    var billingId = $(this).find('input[name="billingId"]');
    var submitButton = $(this).find('button[type="submit"]');

    submitButton.prop('disabled', true);
    submitButton.addClass('btn-loading');

    userBillingResource.delete(billingId.val(), {
      success: function (resp) { 
        AVNotify(resp.message, 'success', true, 5, true);
        reload(true);
      },
      error: function(xhr, status, err) {
        if (xhr.status === 409) {
          deletePaymentMethodForm.modal('hide');
          conflictPaymentMethodModal.modal('show', submitButton);
          return;
        }

        AVNotify(xhr.responseJSON && xhr.responseJSON.message ? xhr.responseJSON.message : err, 'danger', null, null, true);
        reload(true);
      }
    });
  });

  conflictPaymentMethodModal.on('show.bs.modal', function(e) {
    var ccNumber = $(this).find('.cc-number');

    if (!(e.relatedTarget || ccNumber.text())) {
      e.preventDefault();
      return;
    }

    // update credit card data
    if (e.relatedTarget) {
      var button = $(e.relatedTarget);
  
      ccNumber.text(button.data('ccNumber'));
    }
  });
});